<template>
<div class="chapter">
<div class="inner_page">
<div class="part" id="p01">
<h1 class="part"><a href="#/text/9780062016591_Contents#c005"><em>By Myself</em></a></h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062016591_Part_1.vue?325da7ea